import { Box, Flex, useColorMode, useColorStyle } from '@tonic-one/react';
import EmailAndCollaborationProtection from '../components/EmailAndCollaborationProtection';
import EnableEmailAndCollaboration from './EnableEmailAndCollaboration';
import GradientBackground from '../components/GradientBackground';

const PoseidonBasedUpdateToVisionOne = ({
  isFoundation,
  provisionNewCas,
  setLoading,
}: {
  isFoundation: boolean;
  provisionNewCas: () => void;
  setLoading: (load: boolean) => void;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <Box
      position="relative"
      width="100%"
      minHeight="100vh"
      backgroundColor={colorStyle.background.primary}
    >
      <GradientBackground />

      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        minHeight="100vh"
        px="96px"
        py="64px"
        position="relative"
        zIndex={1}
      >
        {/* Marketing Content */}
        <Box width="100%" maxWidth="866px" mb="24px">
          <EmailAndCollaborationProtection setLoading={setLoading} />
        </Box>

        {/* Two-step Card */}
        <Box width="100%" maxWidth="866px">
          <EnableEmailAndCollaboration
            isFoundation={isFoundation}
            provisionNewCas={provisionNewCas}
          />
        </Box>
      </Flex>
    </Box>
  );
};
export default PoseidonBasedUpdateToVisionOne;
